import { render, staticRenderFns } from "./Credit.vue?vue&type=template&id=4efec056&"
import script from "./Credit.vue?vue&type=script&lang=js&"
export * from "./Credit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports